export enum LocalStorageKeys {
  CONNEXX_IMPERSONATED_SALES_ACCOUNT_ID = "CONNEXX_IMPERSONATED_SALES_ACCOUNT_ID",
  CONNEXX_SHOW_TABLE_FILTERS = "CONNEXX_SHOW_TABLE_FILTERS",
  CONNEXX_THEME = "CONNEXX_THEME",
  CONNEXX_SCAN_INVOICE_FEATURE_SEEN = "CONNEXX_SCAN_INVOICE_FEATURE_SEEN",
  // "1" once the user has opened the Services page: hides its "New" tag.
  CONNEXX_SERVICES_PAGE_SEEN = "CONNEXX_SERVICES_PAGE_SEEN",
  // Local date (YYYY-MM-DD) on which the user chose "Hide for today" on the
  // Import items prompt; the prompt returns the next day.
  CONNEXX_IMPORT_ITEMS_PROMPT_HIDDEN_ON = "CONNEXX_IMPORT_ITEMS_PROMPT_HIDDEN_ON",
  CONNEXX_SIDEBAR_COLLAPSED = "CONNEXX_SIDEBAR_COLLAPSED",
  CONNEXX_REMEMBER_DATE_RANGE = "CONNEXX_REMEMBER_DATE_RANGE",
  CONNEXX_LAST_DATE_RANGE_PRESET = "CONNEXX_LAST_DATE_RANGE_PRESET",
  CONNEXX_PENDING_SHOPIFY_LINK = "CONNEXX_PENDING_SHOPIFY_LINK",
}

export const setLocalStorageItem = (key: LocalStorageKeys, value: string) => {
  return localStorage.setItem(key, value);
};

export const removeLocalStorageItem = (key: LocalStorageKeys) => {
  return localStorage.removeItem(key);
};

export const getLocalStorageItem = (key: LocalStorageKeys) => {
  return localStorage.getItem(key);
};
